import { render, staticRenderFns } from "./RoundedUserAvatar.vue?vue&type=template&id=78819dc2&scoped=true&"
import script from "./RoundedUserAvatar.vue?vue&type=script&lang=js&"
export * from "./RoundedUserAvatar.vue?vue&type=script&lang=js&"
import style0 from "./RoundedUserAvatar.vue?vue&type=style&index=0&id=78819dc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78819dc2",
  null
  
)

export default component.exports